<template>
  <div>
    <b-modal
      v-model="modalShow"
      title="Select the location"
      header-bg-variant="primary"
      header-text-variant="white"
      size="md"
      no-close-on-backdrop
      centered
    >
      <b-form-group
        v-if="!selectedLocation"
        label="Location"
        class="w-100 mr-4"
      >
        <template v-slot:label>
          Location
        </template>
        <v-select
          :clearable="false"
          class="w-100"
          v-model="location"
          :options="locationOptions"
        ></v-select>
      </b-form-group>
      <template v-slot:modal-footer>
        <div class="text-right mt-1 mr-2">
          <b-button @click="$emit('onHidden')" variant="secondary">
            Cancel
          </b-button>
          <b-button class="ml-2" @click="submitScheduleEvent" variant="primary">
            Comfirm
          </b-button>
        </div>
      </template>
    </b-modal>
  </div>
</template>
<script>
import { mapState, mapGetters } from "vuex";

export default {
  name: "LocationSelectorGroupSessionModal",
  data() {
    return {
      locationOptions: [],
      location: null
    };
  },
  async mounted() {
    await this.fetchLocationOptions();
  },
  methods: {
    async submitScheduleEvent() {
      this.$emit("selectLocation", this.location);
    },
    async fetchLocationOptions() {
      this.locationOptions = this.locations.map(location => ({
        value: location.id,
        label: location.name
      }));

      this.location = this.selectedLocation
        ? { value: this.selectedLocation }
        : this.locationOptions[0];
    }
  },
  computed: {
    ...mapState("layout", {
      currentUser: state => state.currentUser,
      selectedLocation: state => state.selectedLocation
    }),
    ...mapState("client", {
      allLocations: state => state.locations
    }),
    ...mapGetters("layout", ["getCurrentAdjustedDateTime"]),
    locations() {
      let locations = [];
      if (this.currentUser && this.currentUser.role.name == "Tech Staff") {
        locations = [ ...this.allLocations];
      } else {
        locations = [
          ...(this.currentUser && this.currentUser.accessToLocations
            ? this.currentUser.accessToLocations
            : [])
        ];
      }

      return locations;
    },
    modalShow: {
      get() {
        return !!this.$attrs.value;
      },
      set(value) {
        this.$emit("input", value);
      }
    }
  }
};
</script>
